import cn from 'classnames';
import styles from './healthcare-solution-card.module.css';

export interface Solution {
  paperColor: string;
  src: string;
  alt: string;
  title: string;
  text: string;
  btnLabel: string;
  href: string;
  disabledLink?: boolean;
}

export interface SolutionListProps {
  solutions: Solution[];
}

function HealthcareSolutionCard({
  btnLabel,
  href,
  src,
  paperColor,
  text,
  alt,
  title,
  disabledLink,
}: Solution) {
  return (
    <article className={styles.solutionCard}>
      <div
        style={{ backgroundColor: `${paperColor}` }}
        className={styles.solutionCard_image}
      >
        <img src={src} alt={alt} />
      </div>
      <h4 className={styles.solutionCard_title}>{title}</h4>
      <p className={styles.solutionCard_text}>{text}</p>
      <a
        rel="noopener noreferrer"
        target="_blank"
        className={cn(styles.solutionCard_button, [
          { [styles.disabledLink]: disabledLink },
        ])}
        href={href}
      >
        {btnLabel}
      </a>
    </article>
  );
}

export default function HealthcareSolutionList({
  solutions,
}: SolutionListProps) {
  return (
    <ul className={styles.solutionList}>
      {solutions &&
        solutions.map((solution, index) => (
          <li className={styles.solutionList_item} key={index}>
            <HealthcareSolutionCard {...solution} />
          </li>
        ))}
    </ul>
  );
}
